import { ChevronLeftIcon } from "@chakra-ui/icons";
import { Flex, Text } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const PreviousButton = () => {
    const history = useHistory();

    return (
        <Flex flexDirection='row' alignItems='center'>
            <ChevronLeftIcon
                w={10}
                onClick={() => history.goBack()}
                h={10}
                cursor='pointer'
            />
            <Text cursor='pointer' fontWeight={500} fontSize="20px" onClick={() => history.goBack()} marginLeft={5}>Previous</Text>
        </Flex>
    )
  };

  export { PreviousButton };